<div *ngIf="document">
  <app-document-editform [editedDocument]="document"> </app-document-editform>
</div>
